import { Container } from 'react-bootstrap';
import { WrapperPolygonTitle } from '../../DocumentsAuditDashboard/components/DocumentsActionsBar/components/DocumentsTitleBar';
import { SearchDocuments } from './SearchDocuments';

export const DocumentsTitle = () => {
  return (
    <Container
      fluid
      className="p-4 pb-3 d-flex justify-content-between align-items-center"
      style={{ borderBottom: '2px solid rgba(0, 0, 0, 0.16)' }}
    >
      <WrapperPolygonTitle className="d-flex flex-column align-items-center w-100">
        <div className="d-flex w-100 gap-2 flex-column py-2">
          <div className="d-flex">Visualizador de documentos</div>
          <div className="d-flex gap-2 justify-content-between subtitle"></div>
        </div>
      </WrapperPolygonTitle>
      <SearchDocuments />
    </Container>
  );
};
